import { BaseDto } from './base.dto';

export class InvoiceItemDto extends BaseDto {
  invoiceId: number;
  itemName: string;
  itemPrice: number;
  itemQuantity: number;
  itemVat: number;
  itemVatAmount: number;
  itemVatAmountFormat: string;
  itemSubTotal: number;
}
